/* @flow */
import * as React from 'react';
import { withTranslation } from 'react-i18next';

import styles from './styles.module.scss';
import Sidebar from '../Sidebar';
import IconButton from '../IconButton';
import InputText from '../InputText';
import DataLoader from '../DataLoader';

import type { Fetchable, Translate } from '../../types';

type State = {
  query?: string,
};

type Props<T> = {
  title: string,
  items: Fetchable<T[]>,
  canSearchItems?: boolean,
  activeItemId?: number,
  buttons?: T => React.Node,
  // actions
  onListRefresh: () => mixed,
  onCreateItem: () => mixed,
  onSelectItem: (item: T) => mixed,
  onEditItem: (item: T) => mixed,
  onDeleteItem: (item: T) => mixed,
  t: Translate,
};

const normalizeText = (text: string): string => text.toLowerCase();

class CrudSidebar<T> extends React.PureComponent<Props<T>, State> {
  state = {};

  _handleSearchChange = (event: any) => {
    this.setState({ query: event.target.value });
  };

  _filterItems = (items: any[], query?: string) =>
    items.filter(({ name }) =>
      query ? normalizeText(name).indexOf(normalizeText(query)) !== -1 : true
    );

  _renderData = data => {
    const { buttons, activeItemId, onSelectItem, onEditItem, onDeleteItem, t } = this.props;
    return (
      <div className={styles.filters}>
        {this._filterItems(data, this.state.query).map((item, index) => (
          <div key={index} className={item.id === activeItemId ? styles.activeItem : styles.item}>
            <div className={styles.itemName} onClick={() => onSelectItem(item)}>
              {item.name}
            </div>
            <div className={styles.headerButtons}>
              {buttons ? buttons(item) : null}
              <IconButton icon={'edit'} tooltip={t('EDIT')} onClick={() => onEditItem(item)} />
              <IconButton
                icon={'delete'}
                tooltip={t('DELETE')}
                onClick={() => onDeleteItem(item)}
              />
            </div>
          </div>
        ))}
      </div>
    );
  };

  render() {
    const {
      title,
      buttons,
      activeItemId,
      items: { fetching, error, data },
      onListRefresh,
      onSelectItem,
      onCreateItem,
      onEditItem,
      onDeleteItem,
      canSearchItems = false,
      t,
      ...other
    } = this.props;
    return (
      <Sidebar
        {...other}
        title={title}
        onRefresh={onListRefresh}
        onAdd={onCreateItem}
        loading={fetching}
      >
        <div className={styles.root}>
          {canSearchItems && (
            <div className={styles.search}>
              <InputText
                placeholder={t('SEARCH')}
                onChange={this._handleSearchChange}
                value={this.state.query || ''}
              />
            </div>
          )}
          <DataLoader loading={fetching} error={error} data={data} render={this._renderData} />
        </div>
      </Sidebar>
    );
  }
}

export default withTranslation()(CrudSidebar);
